import React from 'react';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import { toFriendlyDateTimeString } from 'helpers/Formatter';

const StyledContainer = styled.div`
  margin-bottom: 16px;
`;

const StyledBody = styled.div`
  border-radius: 8px;
  padding: 16px;
  background-color: ${colors.DIALOG_BACKGROUND};
`;

const StyledSentByOn = styled.div`
  margin-top: 8px;
  padding: 0px 16px 16px;
`;

const Note = ({ body, author, date }) => {
  return (
    <StyledContainer>
      <StyledBody>{body}</StyledBody>
      <StyledSentByOn>
        {getTranslatedString('landlordPortal.maintenanceTicket.note.sentByOn', {
          author: author,
          date: toFriendlyDateTimeString(date, {
            language: getCurrentLocale(),
          }),
        })}
      </StyledSentByOn>
    </StyledContainer>
  );
};

export default Note;
